// @flow
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { getGdprCookieBannerUrl, isGdprCookieBannerVisible } from '../../../selectors';
import { disablePersonalizedAds, hideGdprCookieBanner } from '../../../actions';
import GdprCookieBanner from './component';

type MapStateToProps = {
  visible: boolean,
  url: string,
};

type MapDispatchToProps = {
  denyGdpr: Function,
  acceptGdpr: Function,
};

export function mapStateToProps(state: Object): MapStateToProps {
  return {
    visible: isGdprCookieBannerVisible(state),
    url: getGdprCookieBannerUrl(state),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    denyGdpr: () => {
      dispatch(disablePersonalizedAds());
      dispatch(hideGdprCookieBanner(true));
    },
    acceptGdpr: ({ close }) => {
      dispatch(hideGdprCookieBanner(close));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GdprCookieBanner);



// WEBPACK FOOTER //
// ./app/Gdpr/components/mobile/GdprCookieBanner/container.js